export const BROADCAST_CHANNEL_NAME = 'microsoft_ads_integration_channel';
